import type { ClientArgs } from '@ts-rest/core'
import Cookies from 'js-cookie'

export function createAppClientOptions(
    supportedEndpoints: 'endpoints' | 'identity' = 'endpoints'
): ClientArgs {
    return {
        credentials: 'include',
        baseHeaders: {
            'X-CSRFToken': Cookies.get('csrftoken') ?? '',
        },
        baseUrl: `${import.meta.env.VITE_API_URL ?? window.location.origin}/${supportedEndpoints}`,
    }
}
